var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.8 6H5.2C2.99086 6 1.2 7.79086 1.2 10V24.8C1.2 27.0091 2.99086 28.8 5.2 28.8H30.8C33.0091 28.8 34.8 27.0091 34.8 24.8V10C34.8 7.79086 33.0091 6 30.8 6Z",
    stroke: "#B8B8BC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 24C21.6451 24 24.6 21.0451 24.6 17.4C24.6 13.7549 21.6451 10.8 18 10.8C14.3549 10.8 11.4 13.7549 11.4 17.4C11.4 21.0451 14.3549 24 18 24Z",
    stroke: "#B8B8BC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 6L14.4 1.8H21.6L24 6",
    stroke: "#B8B8BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.29e39e27072a67881bb5ede842ae88dd.svg";
export { ForwardRef as ReactComponent };